"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeFetchRuleSetBufferFromSeeds = exports.fetchRuleSetBufferFromSeeds = exports.findRuleSetBufferPda = exports.getRuleSetBufferGpaBuilder = exports.safeFetchAllRuleSetBuffer = exports.fetchAllRuleSetBuffer = exports.safeFetchRuleSetBuffer = exports.fetchRuleSetBuffer = exports.deserializeRuleSetBuffer = exports.getRuleSetBufferAccountDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getRuleSetBufferAccountDataSerializer() {
    return (0, serializers_1.struct)([['serializedRuleSet', (0, serializers_1.bytes)()]], {
        description: 'RuleSetBufferAccountData',
    });
}
exports.getRuleSetBufferAccountDataSerializer = getRuleSetBufferAccountDataSerializer;
function deserializeRuleSetBuffer(rawAccount) {
    return (0, umi_1.deserializeAccount)(rawAccount, getRuleSetBufferAccountDataSerializer());
}
exports.deserializeRuleSetBuffer = deserializeRuleSetBuffer;
async function fetchRuleSetBuffer(context, publicKey, options) {
    const maybeAccount = await context.rpc.getAccount((0, umi_1.publicKey)(publicKey, false), options);
    (0, umi_1.assertAccountExists)(maybeAccount, 'RuleSetBuffer');
    return deserializeRuleSetBuffer(maybeAccount);
}
exports.fetchRuleSetBuffer = fetchRuleSetBuffer;
async function safeFetchRuleSetBuffer(context, publicKey, options) {
    const maybeAccount = await context.rpc.getAccount((0, umi_1.publicKey)(publicKey, false), options);
    return maybeAccount.exists ? deserializeRuleSetBuffer(maybeAccount) : null;
}
exports.safeFetchRuleSetBuffer = safeFetchRuleSetBuffer;
async function fetchAllRuleSetBuffer(context, publicKeys, options) {
    const maybeAccounts = await context.rpc.getAccounts(publicKeys.map((key) => (0, umi_1.publicKey)(key, false)), options);
    return maybeAccounts.map((maybeAccount) => {
        (0, umi_1.assertAccountExists)(maybeAccount, 'RuleSetBuffer');
        return deserializeRuleSetBuffer(maybeAccount);
    });
}
exports.fetchAllRuleSetBuffer = fetchAllRuleSetBuffer;
async function safeFetchAllRuleSetBuffer(context, publicKeys, options) {
    const maybeAccounts = await context.rpc.getAccounts(publicKeys.map((key) => (0, umi_1.publicKey)(key, false)), options);
    return maybeAccounts
        .filter((maybeAccount) => maybeAccount.exists)
        .map((maybeAccount) => deserializeRuleSetBuffer(maybeAccount));
}
exports.safeFetchAllRuleSetBuffer = safeFetchAllRuleSetBuffer;
function getRuleSetBufferGpaBuilder(context) {
    const programId = context.programs.getPublicKey('mplTokenAuthRules', 'auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg');
    return (0, umi_1.gpaBuilder)(context, programId)
        .registerFields({
        serializedRuleSet: [0, (0, serializers_1.bytes)()],
    })
        .deserializeUsing((account) => deserializeRuleSetBuffer(account));
}
exports.getRuleSetBufferGpaBuilder = getRuleSetBufferGpaBuilder;
function findRuleSetBufferPda(context, seeds) {
    const programId = context.programs.getPublicKey('mplTokenAuthRules', 'auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg');
    return context.eddsa.findPda(programId, [
        (0, serializers_1.string)({ size: 'variable' }).serialize('rule_set'),
        (0, serializers_1.publicKey)().serialize(seeds.owner),
    ]);
}
exports.findRuleSetBufferPda = findRuleSetBufferPda;
async function fetchRuleSetBufferFromSeeds(context, seeds, options) {
    return fetchRuleSetBuffer(context, findRuleSetBufferPda(context, seeds), options);
}
exports.fetchRuleSetBufferFromSeeds = fetchRuleSetBufferFromSeeds;
async function safeFetchRuleSetBufferFromSeeds(context, seeds, options) {
    return safeFetchRuleSetBuffer(context, findRuleSetBufferPda(context, seeds), options);
}
exports.safeFetchRuleSetBufferFromSeeds = safeFetchRuleSetBufferFromSeeds;
//# sourceMappingURL=ruleSetBuffer.js.map